import TopCompaniesTabs from './TopCompaniesTabs';

export default TopCompaniesTabs;
